import React from 'react';
import BrotherCardBase from './BrotherCardBase';

// Alumni: profile under /alumni, subtitle is major only.
function AlumCard(props) {
  return (
    <BrotherCardBase
      name={props.name}
      headshot={props.headshot}
      routePrefix="/alumni"
      subtitle={props.major || undefined}
    />
  );
}

export default AlumCard;
